import { Auth } from 'aws-amplify'

/**
 * Prevents unauthenticated users from accessing dashboard
 * @param next
 * @param store
 * @returns {*}
 */
export default function ({ next, store }) {
  Auth.currentSession().then((res) => {
    Auth.currentUserInfo().then(userInfo => {
      store.dispatch('login', {
        token: res.getAccessToken().getJwtToken(),
        username: res.getAccessToken().decodePayload().username,
        attributes: userInfo.attributes,
        expiry: res.getAccessToken().decodePayload().exp
      })

      next()
    })
  })
    .catch(() => {
      next({ name: 'signin' })
    })
}
